var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9775 12L6.84784 7.86985C5.01074 9.17585 2.4793 8.85639 1.02429 7.13495C-0.430717 5.41352 -0.323879 2.86438 1.27007 1.27071C2.8636 -0.323651 5.41313 -0.430944 7.13499 1.0239C8.85686 2.47874 9.17651 5.01028 7.87032 6.84743L12 10.9776L10.9782 11.9993L10.9775 12ZM4.33535 1.44556C2.96508 1.44526 1.78289 2.40707 1.50453 3.74869C1.22618 5.0903 1.92815 6.44299 3.18546 6.98778C4.44276 7.53256 5.90983 7.11971 6.69844 5.99918C7.48705 4.87865 7.38045 3.35842 6.44318 2.35889L6.88036 2.79243L6.38754 2.30108L6.37887 2.29241C5.83821 1.74845 5.10232 1.4435 4.33535 1.44556Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b0de411041453f521a4a41dd16e7fda2.svg";
export { ForwardRef as ReactComponent };